<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-icon
            size="large"
            :src="icon"
            :style="color"
            class="header-icon-start"
          />
        </ion-buttons>
        <ion-title>{{ title }}</ion-title>
        <ion-buttons slot="end">
          <ion-icon
            size="large"
            name="arrow-back"
            class="header-icon-end"
            @click="goToHome"
          />
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-row class="ion-padding mb1">{{ description }}</ion-row>
      <ion-row>
        <v-calendar
          mode="single"
          tint-color="#f142f4"
          :min-date="new Date()"
          :theme-styles="themeStyles"
          :first-day-of-week="2"
          :disabled-dates="disabledDates"
          :attributes="attributes"
          is-expanded
          is-inline
          @dayclick="event => dateClick(event)"
        />
      </ion-row>
    </ion-content>
  </div>
</template>

<script>
import Vue from 'vue'
import VCalendar from 'v-calendar'
Vue.use(VCalendar)

export default {
  name: 'Detail',
  data() {
    return {
      title: '',
      color: '',
      icon: '',
      description: '',
      disabledDates: {
        weekdays: [1, 7],
      },
      attributes: [
        {
          key: 'today',
          highlight: true,
          dates: new Date(),
        },
      ],
      themeStyles: {
        wrapper: {
          border: '0',
        },
        header: {
          color: '#fafafa',
          backgroundColor: '#f142f4',
          borderColor: '#404c59',
          borderWidth: '1px 1px 0 1px',
        },
        headerVerticalDivider: {
          borderLeft: '1px solid #404c59',
        },
        weekdays: {
          color: '#ffffff',
          backgroundColor: '#f142f4',
          borderColor: '#ff0098',
          borderWidth: '0 1px',
          padding: '5px 0 10px 0',
        },
        weekdaysVerticalDivider: {
          borderLeft: '1px solid #404c59',
        },
        weeks: {
          border: '1px solid #dadada',
        },
      },
    }
  },
  mounted() {
    if (localStorage.params) {
      const params = JSON.parse(localStorage.params)
      this.title = params.title
      this.icon = params.icon
      this.color = params.color
      this.description = params.description
      this.disabledDates = {
        weekdays: params.disabledDates,
      }
      if (params.date) {
        this.attributes = [
          {
            key: 'today',
            highlight: true,
            dates: new Date(
              params.date.year,
              params.date.month - 1,
              params.date.day,
            ),
          },
        ]
      }
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/specialties')
    },
    async dateClick(event) {
      if (!event.isDisabled) {
        let params = JSON.parse(localStorage.params)
        params.date = {
          day: event.day,
          month: event.month,
          year: event.year,
        }
        params.dateFormatted = event.ariaLabel
        localStorage.params = JSON.stringify(params)

        this.$router.push('schedule')
      }
    },
  },
}
</script>

<style scoped>
ion-toolbar {
  --background: #ededed;
  height: 94px;
}

ion-header ion-toolbar:first-child {
  padding-top: 15px;
}

.header-icon-start {
  margin: 19px 15px 18px;
}

.header-icon-end {
  margin-right: 20px;
  color: #4d206a;
}

.mb1 {
  margin-bottom: 1em;
}
</style>
